import { Card } from './Card.js';
import { fmtPct } from '../utils.js';
import { useMoney } from '../money.js';
import { SLEEVE_BY_ID, type SleeveId } from '@agio/core/domain';

export interface PositionRow {
  position_id: string;
  fund_id: string;
  security_name: string;
  isin: string | null;
  quantity: number | null;
  value: number | null;
  sleeve: string | null;
  report_date: string;
}

/** Latest position-level holdings ("ticket level") extracted from the monthly PDF. */
export function PositionsTable({ positions }: { positions: PositionRow[] }) {
  const money = useMoney();
  if (positions.length === 0) return null; // graceful — appears once a monthly PDF lands
  const total = positions.reduce((a, p) => a + (p.value ?? 0), 0);
  return (
    <Card title={`ניירות ערך · ${positions[0].report_date}`}>
      <div className="max-h-96 overflow-y-auto">
        <table className="w-full text-sm">
          <thead className="sticky top-0 bg-card">
            <tr className="border-b border-border text-right text-muted-foreground">
              <th className="py-2 font-normal">נייר</th>
              <th className="py-2 font-normal">אפיק</th>
              <th className="py-2 font-normal">שווי</th>
              <th className="py-2 font-normal">% מהקרן</th>
            </tr>
          </thead>
          <tbody>
            {positions.map((p) => (
              <tr key={p.position_id} className="border-b border-border/50">
                <td className="py-2">{p.security_name}</td>
                <td className="py-2 text-xs text-muted-foreground">
                  {p.sleeve ? SLEEVE_BY_ID[p.sleeve as SleeveId]?.displayNameHe ?? p.sleeve : '—'}
                </td>
                <td className="py-2 tabular-nums">{money(p.value, p.fund_id)}</td>
                <td className="py-2 tabular-nums text-muted-foreground">
                  {p.value && total ? fmtPct(p.value / total, 1) : '—'}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Card>
  );
}
